/**
 * @generated SignedSource<<701e864ed1ba74ffea7c7583cfaf12e2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DenyRespondentsInput = {
  clientMutationId?: string | null;
  participantIds?: ReadonlyArray<string | null> | null;
  respondentIds?: ReadonlyArray<string | null> | null;
  studyId: string;
};
export type ParticipantsBatchMutations_DenyRespondents_Mutation$variables = {
  input: DenyRespondentsInput;
};
export type ParticipantsBatchMutations_DenyRespondents_Mutation$data = {
  readonly denyRespondents: {
    readonly study: {
      readonly id: string;
      readonly needsReviewCount: number | null;
      readonly rejectedCount: number | null;
    } | null;
  } | null;
};
export type ParticipantsBatchMutations_DenyRespondents_Mutation = {
  response: ParticipantsBatchMutations_DenyRespondents_Mutation$data;
  variables: ParticipantsBatchMutations_DenyRespondents_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DenyRespondentsPayload",
    "kind": "LinkedField",
    "name": "denyRespondents",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "StudyNode",
        "kind": "LinkedField",
        "name": "study",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "needsReviewCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rejectedCount",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ParticipantsBatchMutations_DenyRespondents_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ParticipantsBatchMutations_DenyRespondents_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "2b5e1f11d407d38fc17366413a032cb2",
    "id": null,
    "metadata": {},
    "name": "ParticipantsBatchMutations_DenyRespondents_Mutation",
    "operationKind": "mutation",
    "text": "mutation ParticipantsBatchMutations_DenyRespondents_Mutation(\n  $input: DenyRespondentsInput!\n) {\n  denyRespondents(input: $input) {\n    study {\n      id\n      needsReviewCount\n      rejectedCount\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f6ccc2756844924f1721e17ed4d527e8";

export default node;
